import React from 'react';
import {
  ListItemText as MUIListItemText,
  ListItemTextProps as MUIListItemTextProps,
} from '@mui/material';

export const ListItemText = (props: MUIListItemTextProps) => (
  <MUIListItemText {...props} />
);
